export default __webpack_public_path__ + "static/media/banana.022cf584.png";